<template>
	<div>
		<v-row class="my-5" justify="center">
			<v-col cols="12" sm="8" md="6" lg="4" xl="3" align="center">
				<template>
					<v-btn
						class="btn-text btn-multiline mb-6"
						color="primary"
						x-large
						block
						translate
						:href="
							$i18n.locale == 'en'
								? 'https://www.pllenty.com/wp-content/uploads/2025/05/TFF-mobile-demo-en-2025.mp4'
								: 'https://www.pllenty.com/wp-content/uploads/2024/05/TFF-mobile-demo-fr-2024.mp4'
						"
						target="_blank"
					>
						<span class="text-center text-wrap" translate>
							{{ $t(["Volunteer and Participant Flow"]) }}
						</span>
					</v-btn>
				</template>

				<template>
					<v-btn
						class="btn-text btn-multiline mb-6"
						color="primary"
						x-large
						block
						translate
						:href="
							$i18n.locale == 'en'
								? 'https://www.pllenty.com/wp-content/uploads/2025/05/TFF-refund-demo-en-2025.mp4'
								: 'https://www.pllenty.com/wp-content/uploads/2024/05/TFF-refund-demo-fr-2024.mp4'
						"
						target="_blank"
					>
						<span class="text-center text-wrap" translate>
							{{ $t(["Refund Flow"]) }}
						</span>
					</v-btn>
				</template>

				<v-btn
					class="mt-3"
					style="font-size: 12px"
					text
					translate
					@click="backToHome()"
				>
					{{ $t(["Back"]) }}
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>
export default {
	name: "VideoTutorials",
	data() {
		return {};
	},
	methods: {
		backToHome() {
			this.$router.push("/home");
		},
	},
};
</script>

<style lang="scss" scoped></style>
